import { TranslationService } from '../../../shared/translation/translation.service';
import { CommitteeDto } from '../../../committees/shared/dto/committee.dto';
import { NotificationService } from '../../../shared/notification/notification.service';
import { SelectItem } from 'primeng/api';
import { PagedResultGeneric } from '../../../shared/model/paged-result.model';
import { ObservationService } from '../../../shared/observation/observation.service';
import { CommitteeService } from 'src/app/committees/shared/committee.service';
import { Component, OnInit } from '@angular/core';
import { CommitteeSearchDto } from 'src/app/committees/shared/dto/committee-search.dto';
import { CommitteeMemberDto } from 'src/app/committees/shared/dto/committee-member.dto';
import { CommitteeMemberService } from 'src/app/committees/shared/committee-member.service';

@Component({
  selector: 'wl-profile-add-to-committee',
  templateUrl: './profile-add-to-committee.component.html',
  styleUrls: ['./profile-add-to-committee.component.less'],
    standalone: false
})
export class ProfileAddToCommitteeComponent implements OnInit {
  public show = false;
  public profileId: number;
  public committees: SelectItem[];
  public member: CommitteeMemberDto;

  constructor(
    private _committeeService: CommitteeService,
    private _committeeMemberService: CommitteeMemberService,
    private _observationService: ObservationService,
    private _notificationService: NotificationService,
    private _translationService: TranslationService
  ) {
    this.initNewMemberDto();
  }

  ngOnInit(): void {
    const search = new CommitteeSearchDto();
    search.PageSize = 0;
    this._committeeService.search(search).then((data: PagedResultGeneric<CommitteeDto>) => {
      this.committees = data?.Result.map((x) => ({ label: x.Name, value: x.CommitteeID }));
    });
  }

  public openDialog(profileId: number) {
    this.profileId = profileId;
    this.show = !this.show;
  }

  public cancel() {
    this.initNewMemberDto();
    this.show = false;
  }

  public save() {
    this.member.ProfileID = this.profileId;
    this._committeeMemberService
      .create(this.member)
      .then((id: number) => {
        const committeeName = this.committees.find((x) => x.value === this.member.CommitteeID).label;
        const successMessage = this._translationService.getInstant('profiles.view.committees.added-to-committee') + ' ' + committeeName;
        this._notificationService.success(successMessage);
        this._observationService.profileUpdated(this.profileId);
        this.cancel();
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }

  private initNewMemberDto() {
    this.member = { ProfileID: this.profileId, CommitteeID: 0, Active: true, MemberSince: new Date() } as CommitteeMemberDto;
  }
}
